


























































import { Component } from "vue-property-decorator";
import {
  PaginaRevista,
  RevistasService,
  Revista,
} from "@/services/revistas.service";
import AlterarImagemPaginaRevista from "./AlterarImagemPaginaRevista.vue";
import AdicionarPaginaRevista from "./AdicionarPaginaRevista.vue";
import Loading from "@/shared/components/loading.vue";
import Confirm from "@/shared/components/confirm.vue";
import CardRevista from "../CardRevista.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
@Component({
  components: {
    Loading,
    Confirm,
    AlterarImagemPaginaRevista,
    AdicionarPaginaRevista,
    CardRevista,
  },
})
export default class CentralNotificacoes extends mixins(GlobalMixin) {
  paginasRevista: PaginaRevista[] = [];
  revista: Revista = {} as Revista;
  loading = false;
  mounted() {
    this.fetchRevista();
    this.fetchPaginasRevista();
  }
  get idCatalogo() {
    return this.$route.params.idCatalogo;
  }
  get idRevista() {
    return this.$route.params.idRevista;
  }
  async fetchRevista() {
    this.revista = await RevistasService.obterRevista(this.idRevista);
  }
  async fetchPaginasRevista() {
    this.loading = true;
    this.paginasRevista = await RevistasService.listarPaginasDaRevista(
      this.idRevista
    );
    const cardRevista = this.$refs.cardRevista as CardRevista;
    cardRevista.fetchRevista();
    this.loading = false;
  }
  async excluirItem(item: PaginaRevista) {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Excluir Página ${item.numeroPagina}`;
    const text = `Deseja realmente excluir a página ${item.numeroPagina}
    da revista ${this.revista.nome} e os produtos ?`;
    const res = await modalConfirm.open(title, text);
    if (res) {
      this.startLoader();
      await RevistasService.deletarPaginaRevistaEProdutos(item).finally(
        this.stopLoader
      );
      this.fetchPaginasRevista();
    }
  }
  async alterarImagem(item: PaginaRevista) {
    const modalAlterarImagem = this.$refs
      .alterarImagem as AlterarImagemPaginaRevista;
    await modalAlterarImagem.alterarImagemPaginaRevista(
      item.idRevista,
      item.idPaginaRevista
    );
    this.fetchPaginasRevista();
  }
  async novoItem() {
    const modalAdicionarPagina = this.$refs
      .adicionarPagina as AdicionarPaginaRevista;
    await modalAdicionarPagina.adicionarPaginaRevista(this.idRevista);
    this.fetchPaginasRevista();
  }

  async trocarNumeroPaginaRevista(indice: number, acao: string) {
    let pag1 = {} as PaginaRevista;
    let pag2 = {} as PaginaRevista;
    if (acao === "up") {
      if (indice > 0) {
        pag1 = this.paginasRevista[indice - 1];
        pag2 = this.paginasRevista[indice];
      } else {
        return "";
      }
    } else if (acao === "down") {
      if (indice < this.paginasRevista.length - 1) {
        pag1 = this.paginasRevista[indice];
        pag2 = this.paginasRevista[indice + 1];
      } else {
        return "";
      }
    }
    this.loading = true;
    await RevistasService.trocarNumeroPaginaRevista(pag1, pag2);
    this.fetchPaginasRevista();
  }
}
